module.exports = __webpack_public_path__ + "static/media/rainbow-starry.4918f05a.jpg";